
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|4345|8239|9771)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
